import React, { useState } from "react";
import styles from "./SearchDialog.module.css";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import history from "core/helper/Helper";
import { RouterName } from "shared/RouterName";
import CloseIcon from "@material-ui/icons/Close";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SearchDialog = ({ open, onClose }) => {
  const [value, setValue] = useState("");

  const handleClose = () => {
    onClose();
  };

  const handleSearch = () => {
    onClose();
    history.push(`${RouterName.Products.search.url}/${value}`);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      className={styles.dia_container}
      fullWidth={true}
      TransitionComponent={Transition}
    >
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Search Everything!!!"
          type="email"
          fullWidth
          onChange={(event) => {
            setValue(event.target.value);
          }}
          onKeyUp={(event) => {
            if (event.keyCode === 13) {
              handleSearch();
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color="secondary"
          startIcon={<CloseIcon />}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSearch}
          color="primary"
          startIcon={<AddShoppingCartIcon />}
        >
          Search
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SearchDialog;
